import React from 'react';
import axios from './Axios/Default';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.js';
import './index.css';
import './custom.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import store from "./Stores/store";
import Swal from 'sweetalert2';
import { Provider } from 'react-redux';
import { AUTH_SUCCESS, AUTH_LOGOUT, logout } from './Stores/Action/AuthAction';

const REFRESH_URL = '/refresh';
const LOGIN_URL = '/login';

const replaceUrl = obj => {
    for (let key in obj) {
        if (Array.isArray(obj[key])) {
            for (let a of obj[key]) {
                replaceUrl(a);
            }
        } else if (typeof obj[key] == 'object') {
            replaceUrl(obj[key]);
        } else {
            if (key == 'image_name') {
                obj[key] = obj[key].replace('assets.modena.com', 'assetsdev.modena.com');
            }
        }
    }
}

axios.interceptors.response.use(
    res => {
        replaceUrl(res);
        return res;
    },
    async error => {
        const _orgRequest = error.config;
        if ((error.response.status == 403 || error.response.status == 401)  && !_orgRequest._retry) {
            _orgRequest._retry = true;
            const refreshToken = localStorage.getItem('refresh_token');
            if (error.config.url === REFRESH_URL || error.config.url === LOGIN_URL) {
                return Promise.reject(error);
            } else {
                const response = await axios.post(REFRESH_URL, { refreshToken }).catch(errorRefresh => {
                    store.dispatch({ type: AUTH_LOGOUT });
                    return Promise.reject(error);
                });
                if (response && response.status == 200) {
                    const { access_token, refresh_token } = response.data;
                    const new_access_token = access_token;
                    const new_refresh_token = refresh_token;
                    const old_access_token = _orgRequest.headers['Authorization'];
                    const [header, payload] = old_access_token.split('.');
                    const { userid, username, nik, fullname, email, phone, position, department, job_status, job_title, office, cost_center, role_id, role_name, avatar  } = JSON.parse(atob(payload));
                    _orgRequest.headers['Authorization'] = `Bearer ${new_access_token}`;
                    axios.defaults.headers.common['Authorization'] = `Bearer ${new_access_token}`;
                    localStorage.setItem('access_token', new_access_token);
                    localStorage.setItem('refresh_token', new_refresh_token);
                    localStorage.removeItem('avatar');
                    store.dispatch({ type: AUTH_SUCCESS, userInfo: { userid, username, nik, fullname, email, phone, position, department, job_status, job_title, office, cost_center, role_id, role_name, avatar } });
                    return axios(_orgRequest);
                } else {
                    store.dispatch(logout());
                    return Promise.reject(error);
                }
            }

        } else {
            const { code } = error;
            if (code == 'ERR_NETWORK') {
                Swal.fire({
                    icon: 'error',
                    title: 'Network Error!',
                    text: 'Request fail, please check your connection!'
                });
            }
            return Promise.reject(error);
        }
    }
);

const access_token = localStorage.getItem('access_token');
if (access_token) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${access_token}`;
    axios
        .get('api/v1/admin/verify/me')
        .then(res => {
            if (res && res.status == 200) {
                const [header, payload] = access_token.split('.');
                const { userid, username, nik, fullname, email, phone, position, department, job_status, job_title, office, cost_center, role_id, role_name, avatar } = JSON.parse(atob(payload));
                const tempImageName = localStorage.getItem('avatar') || avatar;
                store.dispatch({ type: AUTH_SUCCESS, userInfo: { userid, username, nik, fullname, email, phone, position, department, job_status, job_title, office, cost_center, role_id, role_name, avatar } });
            }
        })
        .catch(error => {
            console.log('Token invalid', error);
            if (!window.location.href.includes('/login')) {
                localStorage.setItem('last_path', window.location.pathname);
                window.location.href = "/login";
            }
        });
}

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
    <Provider store={store}>
        <App />
    </Provider>
);

reportWebVitals();